// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/rastfeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const rastfederDE: PageEntry = {
  id: "post.rastfeder",
  locale: "de",
  slug: "rastfeder",
  seo: {
    title: "Glossar: Rastfeder einfach erklärt | Dietz GmbH",
    description: "Rastfedern sind spezielle Federn, die dazu dienen, Bauteile in einer bestimmten Position zu fixieren. Diese Federn verriegeln durch ihre spezielle Form in einem vordefinierten Rast",
  },
  type: "post",
  h1: "Glossar: Rastfeder einfach erklärt",
  intro: "Rastfedern sind spezielle Federn, die dazu dienen, Bauteile in einer bestimmten Position zu fixieren. Diese Federn verriegeln durch ihre spezielle Form in einem vordefinierten Rastpunkt und bieten so Stabilität und Sicherheit in verschiedenen mechanischen Anwendungen. Häufig werden Rastfedern in Schaltermechanismen, Verschlüssen oder anderen Baugruppen verwendet, um eine klare Positionierung zu gewährleisten. Die Auswahl der richtigen Rastfeder hängt von den Anforderungen an die Haltekraft, die Materialbeschaffenheit und die Konstruktion des Gesamtsystems ab. Durch ihre vielfältigen Anwendungsmöglichkeiten spielen Rastfedern eine wichtige Rolle in der Mechanik.",
  blocks: [

  ],
};
